import { LdapService } from './core/services/ldap.service';
import { SecurityLdapModule } from './security-ldap/security-ldap.module';
import { BrowserModule } from '@angular/platform-browser';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BzTabModule } from './../shared/components/tab/tab.module';
import { CommonModule } from '@angular/common';
import { BzSwitchModule } from '../shared/components/switch/switch.module';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { BzTreeModule } from '../shared/components/tree/tree.module';
import { BzgTabsModule } from 'bz-genome-angular';
import { SharedModule } from './../shared/shared.module';
// This Module's Components
import { SecurityComponent } from './security.component';
import { SecurityAuthorizationComponent } from './security-authorization/security-authorization.component';
import { BzAuthorizationDetailComponent } from './security-authorization/authorization-detail/authorization-detail.component';

// Services
import { AuthorizationService } from 'app/security/core/services/authorization.service';
import { AuthenticationService } from './core/services/authentication.service';
import { SecurityService } from 'app/security/core/services/security.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SecurityAuthenticationModule } from './security-authentication/security-authentication.module';
import { SecurityAuthenticationRefactorModule } from './security-authentication-refactor/security-authentication-refactor.module';
import { SecurityApiKeyConfigurationComponent } from './security-api-key-configuration/security-api-key-configuration.component';
import { ApiKeyService } from './core/services/api-key.service';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CommonModule,
        BzTabModule,
        InfiniteScrollModule,
        AccordionModule.forRoot(),
        BzSwitchModule,
        BrowserModule, FormsModule,
        BzTreeModule,
        BzgTabsModule,
        SecurityLdapModule,
        SharedModule,
        SecurityAuthenticationModule,
        SecurityAuthenticationRefactorModule
    ],
    declarations: [
        SecurityComponent,
        SecurityAuthorizationComponent,
        BzAuthorizationDetailComponent,
        SecurityApiKeyConfigurationComponent
    ],
    exports: [
        SecurityComponent,
        SecurityAuthorizationComponent,
        BzAuthorizationDetailComponent,
        SecurityApiKeyConfigurationComponent,
        SecurityAuthenticationModule,
        SecurityAuthenticationRefactorModule
    ],
    providers: [AuthorizationService, AuthenticationService, SecurityService, LdapService, ApiKeyService]
})
export class SecurityModule { }
